export const ACTIVE_MATCH_KEY = 'kfppc_active_match_v14_6';

export const STORAGE_KEYS = {
  PLAYERS: 'kfppc_players_v14_6',
  TOURNAMENTS: 'kfppc_tournaments_v14_6',
  MATCHES: 'kfppc_matches_v14_6',
  NEWS: 'kfppc_news_v14_6',
  TEAMS: 'kfppc_teams_v14_6',
  TOURNAMENTS_DOUBLES: 'kfppc_tournaments_doubles_v14_6',
  MATCHES_DOUBLES: 'kfppc_matches_doubles_v14_6',
  NEWS_DOUBLES: 'kfppc_news_doubles_v14_6',
  TICKER: 'kfppc_ticker_msg_v14_6',
  REPORT: 'kfppc_commissioner_report_v14_6',
  THEME: 'kfppc_theme_v1', // Device-local preference, NOT synced to Firestore
  LOGO: 'kfppc_logo_v14_6',
};